import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { NativeSelectMode, NativeSelectOption } from '@shared/ui/fields'

export interface TutorLegalSelectFieldProps {
  name: string
  label: string
  options: AppSelectOption[]
  modelValue: string
  state?: 'error' | 'static'
  placeholder?: string
}

interface TutorLegalSelectFieldOptions {
  props: TutorLegalSelectFieldProps
  onUpdate: (value: string) => void
}

interface TutorLegalSelectFieldReturn {
  refNativeOptions: ComputedRef<NativeSelectOption[]>
  refMode: ComputedRef<NativeSelectMode>
  setValue: (option: NativeSelectOption) => void
}

export const useTutorLegalSelectField = (
  { props, onUpdate }: TutorLegalSelectFieldOptions,
): TutorLegalSelectFieldReturn => {
  const refNativeOptions = computed<NativeSelectOption[]>(() =>
    props.options.map(option => ({
      id: option.value,
      value: option.value,
      text: option.text,
      selected: false,
    })))

  const refMode = computed<NativeSelectMode>(() => props.state === 'error' ? 'error' : 'normal')

  const setValue = (option: NativeSelectOption): void => onUpdate(String(option.value ?? ''))

  return {
    refNativeOptions,
    refMode,
    setValue,
  }
}
